import React, {Component} from 'react';
import {translate} from 'react-i18next';
import config from '../../config/config.js';
import axios from 'axios';
import PageHeader from '../elements/PageHeader';
import Select2 from 'react-select2-wrapper';
import AddLocation from '../elements/routes/AddLocation';
import EditRoute from '../elements/routes/EditRoute';
import Sortable from 'react-sortablejs';
import swal from "sweetalert";
import {NotificationManager} from "react-notifications";

class RoutesScreen extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            availableWaitingSpots: [],
            adding: false,
            addingErrors: [],
            addName: '',
            addWaitingSpot: null,
            routes: []
        };

        this.getRoutes = this.getRoutes.bind(this);
        this.handleStartAdding = this.handleStartAdding.bind(this);
        this.handleSaveAdding = this.handleSaveAdding.bind(this);
        this.handleCancelAdding = this.handleCancelAdding.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.changeRouteSort = this.changeRouteSort.bind(this);
        this.removeLocationFromRoute = this.removeLocationFromRoute.bind(this);
    };

    componentDidMount() {
        this.getRoutes();
    }

    getRoutes() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/routes', {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false,
                    routes: response.data.routes,
                    availableWaitingSpots: response.data.availableWaitingSpots
                });
            }
        });
    }

    handleStartAdding() {
        this.setState({
            adding: true,
            addingErrors: [],
            addName: '',
            addWaitingSpot: null
        })
    }

    handleSaveAdding() {
        this.setState({
            loading: true
        });
        let that = this;
        axios(config.server.endpoint + 'backend/route/', {
            method: 'post',
            data: {
                name: that.state.addName,
                waitingSpot: that.state.addWaitingSpot
            }
        }).then((response) => {
            if (response.status === 200) {
                that.setState({
                    loading: false
                });
                if(response.data.success === true) {
                    that.getRoutes();
                    that.setState({
                        adding: false
                    });
                } else {
                    that.setState({
                        addingErrors: response.data.errors
                    });
                }
            }
        });
    }

    handleCancelAdding() {
        this.setState({
            adding: false,
            addingErrors: [],
            addName: '',
            addWaitingSpot: null
        });
    }

    handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    changeRouteSort(routeId, order, sortable) {
        let routes = this.state.routes;
        for(let i = 0; i < routes.length; i++) {
            if(routes[i].id === routeId) {
                routes[i].locations.sort((a, b) => {
                    return order.indexOf(a.id.toString()) - order.indexOf(b.id.toString());
                });
                break;
            }
        }
        this.setState({
            routes: routes
        });
        axios(config.server.endpoint + 'backend/route/locations/order/' + routeId + '/' + order.join('-'), {
            method: 'put'
        });
    }

    removeLocationFromRoute(routeId, locationId) {
        let routes = this.state.routes;
        for(let i = 0; i < routes.length; i++) {
            if(routes[i].id === routeId) {
                routes[i].locations = routes[i].locations.filter((el) => {return el.id !== locationId});
                break;
            }
        }
        this.setState({
            routes: routes
        });
        axios(config.server.endpoint + 'backend/route/location/' + routeId + '/' + locationId, {
            method: 'delete'
        });
    }

    deleteRoute = (routeId) => {
        const { t } = this.props;
        let that = this;
        swal({
            title: t('routes.route.delete.really.title'),
            text: t('routes.route.delete.really.text'),
            icon: 'warning',
            buttons: true,
            dangerMode: true
        }).then((reallyDo) => {
            if (reallyDo) {
                axios(config.server.endpoint + 'backend/route/' + routeId, {
                    method: 'delete'
                }).then((response) => {
                    console.log(response.status, response.data);
                    if(response.status === 200 && response.data.success === true) {
                        NotificationManager.success(t('routes.route.delete.success.title'), t('routes.route.delete.success.text'), 5000);
                        that.getRoutes();
                    }
                })
            }
        })
    };

    render() {
        const { t } = this.props;
        return (
            <div className="RoutesScreen">
                <PageHeader title={t('routes.title')} loading={this.state.loading}/>
                <div className="row m-t">
                    {this.props.roles.find((role) => role === 'ROLE_SHIFT_ADMIN') ? (
                      this.state.adding ? (
                        <div>
                            <div className="col-md-4">
                                <div
                                  className="form-group">
                                    <label>{t('routes.name.label')}</label>
                                    <input type="text" name="addName" className="form-control"
                                           value={this.state.addName} onChange={this.handleInputChange}/>
                                    {(this.state.addingErrors && this.state.addingErrors.name) ? (
                                      <span className="help-block">
                                    {t('location.name.error.' + this.state.addingErrors.name)}
                                </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div
                                  className="form-group">
                                    <label>{t('routes.waitingSpot.label')}</label>
                                    <Select2 data={this.state.availableWaitingSpots.map((el) => {
                                        return {
                                            text: t('default.waitingSpot.' + el), id: el
                                        }
                                    })} value={this.state.addWaitingSpot} onChange={this.handleInputChange}
                                             name="addWaitingSpot"
                                             options={{placeholder: t('routes.waitingSpot.placeholder')}}
                                             className="width-100p block"/>
                                    {(this.state.addingErrors && this.state.addingErrors.waitingSpot) ? (
                                      <span className="help-block">
                                    {t('routes.waitingSpot.error.' + this.state.addingErrors.waitingSpot)}
                                </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="col-md-2">
                                <label>&nbsp;</label>
                                <button className="btn btn-primary btn-block" onClick={this.handleSaveAdding}>
                                    <i className="fa fa-save m-r-xs"/>
                                    {t('default.save')}
                                </button>
                            </div>
                            <div className="col-md-2">
                                <label>&nbsp;</label>
                                <button className="btn btn-default btn-block" onClick={this.handleCancelAdding}>
                                    {t('default.cancel')}
                                </button>
                            </div>
                            <div className="col-xs-12">
                                <div className="hr-line-dashed"/>
                            </div>
                        </div>
                      ) : (
                        <div className="col-xs-12 text-right">
                            <div className="btn-group">
                                <button className="btn btn-primary" onClick={this.handleStartAdding}>
                                    <i className="fa fa-plus m-r-xs"/>
                                    {t('routes.addRouteButton')}
                                </button>
                            </div>
                        </div>
                      )
                    ) : null}
                </div>
                <div className="row">
                    {this.state.routes.map((route, i) => (
                      <div className="col-md-6 m-t" key={i}>
                          <div className="ibox">
                              <div className="ibox-title">
                                  <h5>
                                      {route.name}
                                      <small className="text-muted m-l">
                                          <i className="fa fa-group m-r-xs"/>
                                          {route.waitingSpot}
                                      </small>
                                  </h5>
                                  {this.props.roles.find((role) => role === 'ROLE_SHIFT_ADMIN') ? (
                                    <div className="ibox-tools">
                                        <EditRoute handleClose={this.getRoutes} id={route.id}/>
                                        <AddLocation handleClose={this.getRoutes} id={route.id}/>&nbsp;&nbsp;
                                        <a onClick={() => this.deleteRoute(route.id)} className="text-danger">
                                            <i className="fa fa-trash"/>
                                        </a>
                                    </div>
                                  ) : null}
                              </div>
                              <div className="ibox-content">
                                  {this.props.roles.find((role) => role === 'ROLE_SHIFT_ADMIN') ? (
                                    <Sortable
                                      onChange={(order, sortable, evt) => this.changeRouteSort(route.id, order, sortable)}>
                                        {route.locations.map((location, j) => (
                                          <div key={i + '' + j} data-id={location.id}
                                               className="p-lg border-size-sm location-draggable-container">
                                              <button className="btn btn-default pull-right"
                                                      onClick={() => this.removeLocationFromRoute(route.id, location.id)}>
                                                  <i className="fa fa-close"/>
                                              </button>
                                              <i className="fa fa-sort fa-1-5x m-r"/>
                                              {location.name}
                                          </div>
                                        ))}
                                    </Sortable>
                                  ) : (
                                    route.locations.map((location, j) => (
                                      <div key={i + '' + j} data-id={location.id}
                                           className="p-lg border-size-sm location-draggable-container">
                                          {location.name}
                                      </div>
                                    ))
                                  )}
                              </div>
                          </div>
                      </div>
                    ))}
                </div>
            </div>
        )
    }
}
export default translate()(RoutesScreen);
